<template>
  <div id="container">
    <div class="item-box-content">
      <div class="title-font-style">
        <span>退票信息</span>
      </div>
      <el-form style="padding:20px 30px 0 30px">
        <el-row :gutter="20">
          <el-col :span="18">
            <el-form-item label="退票原因：" label-width="70px">
              <el-input type="textarea" v-model="dataList.mark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="item-box-content">
      <div class="title-font-style">
        <span>申请红字信息表</span>
      </div>
      <el-form class="details-line-height" style="padding:20px 30px 0 30px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="发票类型：">红字发票</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="关联发票编号：">{{ $route.query.invoiceNumber }}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="item-box-content">
      <div class="title-font-style">
        <span>收票信息</span>
      </div>
      <el-form style="padding:20px 30px 0 30px" label-width="70px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="收票人：">
              <el-input v-model="dataList.receivePeople"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话：">
              <el-input  @input.native="onInput" v-model="dataList.receivePhone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="收票地址：">
              <el-address @changAddress="changAddress"></el-address>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="详细地址：">
              <el-input v-model="dataList.receiveAddress"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="item-box-content">
      <div class="title-font-style">
        <span>收票清单</span>
      </div>
    </div>
    <el-row :gutter="20">
      <el-col :span="12">
        <div class="join-remove-inline-block">
          <div style>
            <div style="text-align:center;font-size:16px;font-weight: bold;">红字信息表</div>
            <div style="text-align:right;color:#276CFF;padding-right:20px;">发票金额：{{ dataList.amount }}</div>
          </div>
          <el-table
            style="margin-top:20px;"
            border
            ref="tableRef"
            :data="ticketCollectionList"
            @selection-change="handleSelectionChangeTicketingAreaList"
            tooltip-effect="dark"
            :header-cell-style="tableHeader"
            height="378px"
          >
            <template slot="empty">
              <i class="el-icon-refresh-right" style="padding-right:10px;"></i>
              <span>请选择开票产品！</span>
            </template>
            <el-table-column fixed type="selection"></el-table-column>
            <el-table-column prop="proName" show-overflow-tooltip label="产品名称"></el-table-column>
            <el-table-column show-overflow-tooltip prop="proModel" label="型号"></el-table-column>
            <el-table-column prop="proOrdernum" show-overflow-tooltip label="订货号"></el-table-column>
            <el-table-column label="采购合同编号" show-overflow-tooltip width="110px" prop="pcbNumber"></el-table-column>
            <el-table-column
              label="供应商合同编号"
              show-overflow-tooltip
              width="120px"
              prop="supplierContractNumber"
            ></el-table-column>
            <el-table-column show-overflow-tooltip prop="purchasePrice" label="实付单价"></el-table-column>
            <el-table-column prop="deliverState" show-overflow-tooltip label="发货状态">
              <template slot-scope="scope">
                <div>{{ scope.row.deliverState }}</div>
              </template>
            </el-table-column>

            <el-table-column width="160px" prop="count" label="数量">
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.count"
                  :max="scope.row.maxCount"
                  controls-position="right"
                  :min="1"
                  @change="handleChange(scope.$index, scope.row)"
                ></el-input-number>
              </template>
            </el-table-column>
          </el-table>

          <el-col :span="24" class="join-remove-inline-block-btn">
            <el-button type="primary" @click="moveMissingProductsListAll">全部移出</el-button>
            <el-button type="primary" @click="moveMissingProductsList" plain>移出信息表</el-button>
          </el-col>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="join-remove-inline-block">
          <div style="text-align:center;margin-bottom:20px; font-size:16px;font-weight: bold;">已收票产品</div>

          <el-table
            border
            style="margin-top:40px;"
            ref="tableRef"
            :data="waitTicketCollectionList"
            tooltip-effect="dark"
            @selection-change="handleSelectionChangeTicketProductsList"
            :header-cell-style="tableHeader"
            v-loading="loadingWaitTable"
            height="378px"
            element-loading-text="拼命加载中请稍后..."
            element-loading-spinner="el-icon-loading"
          >
            <template slot="empty">
              <i class="el-icon-folder"></i>
              <span>产品已全部移入开票区！</span>
            </template>
            <el-table-column fixed type="selection" width="55"></el-table-column>
            <el-table-column prop="proName" show-overflow-tooltip label="产品名称"></el-table-column>
            <el-table-column prop="proModel" label="型号"></el-table-column>
            <el-table-column prop="proOrdernum" show-overflow-tooltip label="订货号"></el-table-column>
            <el-table-column label="采购合同编号" width="110px" show-overflow-tooltip prop="pcbNumber"></el-table-column>
            <el-table-column
              label="供应商合同编号"
              width="120px"
              show-overflow-tooltip
              prop="supplierContractNumber"
            ></el-table-column>
            <el-table-column prop="purchasePrice" show-overflow-tooltip label="实付单价"></el-table-column>
            <el-table-column prop="deliverState" show-overflow-tooltip label="发货状态">
              <template slot-scope="scope">
                <div>{{ scope.row.deliverState }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="count" label="数量"></el-table-column>
          </el-table>

          <el-col :span="24" class="join-remove-inline-block-btn">
            <el-button type="primary" @click="moveReportingAreaListAll">全部移入</el-button>
            <el-button type="primary" @click="moveReportingAreaList" plain>移入信息表</el-button>
          </el-col>
        </div>
      </el-col>
    </el-row>
    <el-row style="margin-top:20px;">
      <el-col :span="24">
        <el-button @click="onApplyRedInformation" type="primary">申请红字信息表</el-button>
      </el-col>
      <el-col :span="24" style="margin-top:16px;">申请成功后请尽快前往财务部领取红字信息表，交由供应商后向对方领取红字发票</el-col>
    </el-row>
    <!-------------- 红字申请收款二次确认 -------------->
    <open-or-close
      ref="OpenOrCloseRefs"
      @onUpdataState="onUpdataState"
      :title="title"
      :content="content"
    ></open-or-close>
  </div>
</template>
<script>
import {
  queryInvoiceContent,
  addInvoiceSub
} from '@/api/purchase/purchasePlanList'

import address from '@/components/Address/index'
import openOrClose from '@/components/OpenOrClose/index'
export default {
  components: {
    'el-address': address,
    'open-or-close': openOrClose
  },
  data () {
    return {
      deliverState: ['物流在途', '待入库', '已入库', '已作废', '已发货'],
      queryParamsSearch: {},
      dataList: {
        amount: 0,
        mark: undefined,
        receiveAddress: undefined,
        receivePeople: undefined,
        receivePhone: undefined,
        receiveProcode: undefined,
        receiveProvince: undefined
      }, // 传给后台的数据
      params: {},

      bigArray: [], // 最全数组
      changeMissingProductsList: [], // 收票产品选中
      changeReportingAreaList: [], // 待收票选中
      ticketCollectionList: [], // 收票产品区
      waitTicketCollectionList: [], // 待收票产品区
      redInformationTableList: [],
      ticketedProductsList: [],
      shippedProductList: [],
      loadingWaitTable: false,
      content: '',
      title: ''
    }
  },
  mounted () {
    queryInvoiceContent(this.$route.query.pciId)
      .then((res) => {
        if (res.data.code === 200) {
          this.waitTicketCollectionList = res.data.obj
          this.waitTicketCollectionList.forEach((item, index) => {
            this.waitTicketCollectionList[index].maxCount = item.count
            this.waitTicketCollectionList[index].ids = index
          })
          this.bigArray = JSON.parse(
            JSON.stringify(this.waitTicketCollectionList)
          )
        }
      })
      .catch((err) => {
        console.log(err)
      })
  },
  watch: {
    ticketCollectionList: {
      handler (newVal) {
        this.dataList.amount = 0
        this.ticketCollectionList.forEach((item, index) => {
          this.dataList.amount += item.count * item.purchasePrice
        })
      },
      deep: true
    }
  },
  methods: {
    onInput(e) {
      // 过滤非数字和符号-
      const regName = /^[\d-]+$/
      if (!regName.test(e.target.value)) {
        e.target.value = ''
      } else {
        return true
      }
    },
    // 待收票change
    handleSelectionChangeTicketProductsList (val) {
      this.changeReportingAreaList = val
    },
    // 收票change
    handleSelectionChangeTicketingAreaList (val) {
      this.changeMissingProductsList = val
    },
    // 收票All移动
    moveMissingProductsListAll () {
      this.changeMissingProductsList = JSON.parse(
        JSON.stringify(this.ticketCollectionList)
      )
      this.moveMissingProductsList()
    },
    // 收票移动

    moveMissingProductsList () {
      if (this.changeMissingProductsList.length === 0) {
        this.$message.error('请选中产品')
      } else {
        this.changeMissingProductsList.forEach((param) => {
          this.ticketCollectionList.forEach((item, index) => {
            if (item.ids === param.ids) {
              let isFalse = false
              if (this.waitTicketCollectionList.length > 0) {
                this.waitTicketCollectionList.forEach((val, indexs) => {
                  if (val.ids === param.ids) {
                    this.waitTicketCollectionList[
                      indexs
                    ].count += this.ticketCollectionList[index].count
                    isFalse = true
                  }
                })
                if (!isFalse) {
                  this.waitTicketCollectionList.push(
                    this.ticketCollectionList[index]
                  )
                }
              } else {
                this.waitTicketCollectionList.push(
                  this.ticketCollectionList[index]
                )
              }
            }
          })
        })
        this.changeMissingProductsList.forEach((param) => {
          this.ticketCollectionList.forEach((item, index) => {
            if (item.ids === param.ids) {
              this.ticketCollectionList.splice(index, 1)
              index--
            }
          })
        })
      }
      this.changeMissingProductsList = []
    },
    // 移入收票区All
    moveReportingAreaListAll () {
      this.changeReportingAreaList = JSON.parse(
        JSON.stringify(this.waitTicketCollectionList)
      )
      this.moveReportingAreaList()
    },
    // 移入收票区
    moveReportingAreaList () {
      if (this.changeReportingAreaList.length === 0) {
        this.$message.error('请选中产品')
      } else {
        this.changeReportingAreaList.forEach((param) => {
          this.waitTicketCollectionList.forEach((item, index) => {
            if (item.ids === param.ids) {
              let isFalse = false
              if (this.ticketCollectionList.length > 0) {
                this.ticketCollectionList.forEach((val, indexs) => {
                  if (val.ids === item.ids) {
                    this.ticketCollectionList[
                      indexs
                    ].count += this.waitTicketCollectionList[index].count
                    isFalse = true
                  }
                })
                if (!isFalse) {
                  this.ticketCollectionList.push(
                    this.waitTicketCollectionList[index]
                  )
                }
              } else {
                this.ticketCollectionList.push(
                  this.waitTicketCollectionList[index]
                )
              }
            }
          })
        })
        this.changeReportingAreaList.forEach((param) => {
          this.waitTicketCollectionList.forEach((item, index) => {
            if (item.ids === param.ids) {
              this.waitTicketCollectionList.splice(index, 1)

              index--
            }
          })
        })
      }
      this.changeReportingAreaList = []
    },
    // 数字改变
    handleChange (index, val) {
      if (!this.ticketCollectionList[index].count) {
        this.ticketCollectionList[index].count = 0
      }
      if (
        this.ticketCollectionList[index].count ===
        this.ticketCollectionList[index].maxCount
      ) {
        this.waitTicketCollectionList.forEach((item, indexProductsList) => {
          if (item.ids === this.ticketCollectionList[index].ids) {
            this.waitTicketCollectionList.splice(indexProductsList, 1)
          }
        })
      } else {
        let isBooean = false
        this.waitTicketCollectionList.forEach((item, indexBig) => {
          if (item.ids === this.ticketCollectionList[index].ids) {
            this.waitTicketCollectionList[indexBig].count =
              this.waitTicketCollectionList[indexBig].maxCount -
              (this.ticketCollectionList[index].count || 0)
            isBooean = true
          }
        })
        if (!isBooean) {
          const params = JSON.parse(
            JSON.stringify(this.ticketCollectionList[index])
          )
          params.count =
            this.ticketCollectionList[index].maxCount -
            (this.ticketCollectionList[index].count || 0)
          this.waitTicketCollectionList.push(params)
        }
      }
      this.clearList()
    },
    clearList () {
      this.ticketCollectionList.forEach((item, indexProductsList) => {
        if (item.count === 0) {
          this.ticketCollectionList.splice(indexProductsList, 1)
        }
      })
      this.waitTicketCollectionList.forEach((item, indexAreaList) => {
        if (item.count === 0) {
          this.waitTicketCollectionList.splice(indexAreaList, 1)
        }
      })
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 再次确认
    onUpdataState () {
      addInvoiceSub(this.dataList)
        .then((res) => {
          if (res.data.code === 200) {
            this.$router.push({
              name: 'contractDetails',
              query: {
                pcbId: this.$route.query.pcbId,
                type: this.$route.query.sendType
              }
            })
            this.$message.success('已申请红字信息表，请等待审核！')
            this.$router.push({
              name: 'contractDetails',
              query: {
                type: this.$route.query.sendType,
                pcbId: this.$route.query.pcbId
              }
            })
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 申请红色信息表
    onApplyRedInformation () {
      const dataArray = Object.values(this.dataList)
      if (dataArray.every(item => item)) {
        if (this.ticketCollectionList.length === 0) {
          this.$message.error('请补全信息')
        } else {
          this.dataList.purchaseContractInvocieProductVoList = this.ticketCollectionList
          this.dataList.pciId = this.$route.query.pciId
          this.title = '确认退票'
          this.content = '红字信息表申请发起后不可撤回，是否确认申请？'
          this.$refs.OpenOrCloseRefs.onInitial()
        }
      } else {
        this.$message.error('请填写完整发货信息！')
      }
    },
    // 省市区
    changAddress (val) {
      this.dataList.receiveProcode = val.code
      this.dataList.receiveProvince = val.name
    }
  }
}
</script>
<style lang="scss" scoped></style>
